import React from 'react';

import { media } from '../../services/media';
import { themeStyles } from '../../services/themeStyles';

import { PlusIcon } from '../PlusIcon';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

interface ScoreBarProps {
    score: number;
    minScore: number;
    maxScore: number;
    label: string;
    iconType?: 'green' | 'orange';
    onPlusClick: any;
}

export const ScoreBar: React.FC<ScoreBarProps> = ({
    score = 0,
    minScore = 0,
    maxScore = 1000,
    label = '',
    iconType = 'green',
    onPlusClick,
}) => {
    if (isNaN(score)) {
        return null;
    }

    let sanitizedScore = score;

    if (score > maxScore) {
        sanitizedScore = maxScore;
    } else if (score < minScore) {
        sanitizedScore = minScore;
    }

    return (
        <Wrapper>
            {label && <Label>{label}</Label>}
            <Bar>
                {score !== 0 ? (
                    <Circle
                        style={{
                            left: `${(sanitizedScore * 100) / maxScore}%`,
                        }}
                    />
                ) : (
                    <PlusIcon type={iconType} onClick={onPlusClick} />
                )}
            </Bar>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    text-align: center;

    ${media.max('xl')} {
        margin-bottom: 10px;
    }

    ${media.min('xl')} {
        margin-bottom: 24px;
    }
`;

const Circle = styled.span`
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 32px;
    height: 32px;

    border: 5px solid #fff;
    border-radius: 50%;
    background: transparent;
    box-shadow: 8px 10px 16px 0 rgba(0, 0, 0, 0.45),
        inset -10px -10px 18px -10px rgba(0, 0, 0, 0.45);

    ${media.min('xl')} {
        width: 54px;
        height: 54px;

        border-width: 13px;
        box-shadow: 15px 37px 50px rgba(0, 0, 0, 0.45),
            inset -20px -20px 36px -20px rgba(0, 0, 0, 0.45);
    }

    ${themeStyles(
        'pengestyrke',
        css`
            border: 3px solid #eef0eb;
        `,
    )}
`;

const Label = styled.p``;

const Bar = styled.figure`
    width: 100%;

    position: relative;

    background-color: #fff;

    ${media.max('xl')} {
        height: 13px;
        margin: 10px 0 0;
    }

    ${media.min('xl')} {
        height: 22px;

        margin: 18px 0 0;
    }

    ${themeStyles(
        'upscore',
        css`
            background-image: linear-gradient(
                to right,
                #ee324e 0%,
                #fa692b 15%,
                #febc51 25%,
                #daf237 42%,
                #7dee67 74%,
                #20dcd4 100%
            );

            ${media.max('xl')} {
                border-radius: 5px;
            }

            ${media.min('xl')} {
                border-radius: 16px;
            }
        `,
    )}

    ${themeStyles(
        'pengestyrke',
        css`
            border: 2px solid #133143;
            border-radius: 0;
            width: 100%;
            height: 26px;

            background-image: linear-gradient(
                to right,
                #ff7287 0%,
                #e28157 15%,
                #febc51 25%,
                #daf237 42%,
                #7dee67 74%,
                rgb(52, 204, 51) 100%
            );

            ${media.min('xl')} {
                height: 30px;
            }
        `,
    )}
`;
